import { ListLayout } from "../../../layouts";
import {
  TagsService,
  history,
  notification,
  ProdutosService,
} from "../../../services";
import { Chip, DataGrid } from "../../../components";
import { FormFiltroAvancado } from "./components";
import { filtrosUrl, PermisoesHelper } from "../../../helpers";
import { useEffect, useState } from "react";
import { cacheApi, responseErros } from "../../../utils";
import { useCacheContext } from "../../../contexts/cache.context";

const ListTagsView = () => {
  const { cacheDto, setCacheDto } = useCacheContext();
  const [tags, setTags] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const permissoesHelper = new PermisoesHelper();
  const tagsService = new TagsService();
  const produtoService = new ProdutosService();

  const colunas = [
    {
      field: "ativado",
      headerName: "Status",
      flex: 100,
      valueGetter: (params) =>
        params.value == true ? "Ativado" : "Desativado",
    },
    {
      field: "tipo",
      headerName: "Tipo",
      flex: 200,
    },
    {
      field: "descricao",
      headerName: "Tags",
      flex: 700,
      filtrar: true,
    },
    {
      field: "cor",
      headerName: "Cor",
      flex: 200,
      renderCell: (params) => (
        <Chip
          sx={{
            backgroundColor: `${params.value}DD`,
            borderRadius: "4px",
            height: "23px",
            width: "100%",
            "& .MuiChip-label": {
              fontWeight: "600",
              fontSize: "11px",
              letterSpacing: ".2px",
              color: "white",
            },
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    const filtros = filtrosUrl.get();
    buscarTags(filtros);
  }, []);

  const buscarTags = async function (filter) {
    setLoading(true);
    const result = await tagsService.getAll(filter);
    if (!result.isAxiosError) {
      setTags(result.data.rows);
      setRowCount(result.data.count);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrarTag = function () {
    history.push("/estoque/tags/create");
  };

  const onClickEditTag = function (id) {
    history.push(`/estoque/tags/${id}`);
  };

  async function validarProdutoVinculado(produtoId) {
    const result = await produtoService.validarTagVinculada(produtoId);
    if (result.isAxiosError) {
      setLoading(false);
      responseErros(result);
      return false;
    }
    return true;
  }

  const onClickDeleteTag = async function (id) {
    const data = tags.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${data.descricao}`
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const tagVinculada = await validarProdutoVinculado(id);
      if (!tagVinculada) return;
      const result = await tagsService.deletar(id);
      if (!result.isAxiosError) {
        buscarTags();
        notification.deletadoSucesso();
      } else {
        responseErros(result);
      }
      setLoading(false);
    }
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarTags(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  const buscarPesquisaAvancada = async (filter) => {
    const label = filtrosUrl.getUrl(filter);
    setLoading(true);
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    const cacheBody = {
      dto: { cacheDto, setCacheDto },
      apiFunction: tagsService.getAllFiltroAvancado({
        ...filtrosAvancadosTemp,
        restritiva: true,
        porIntervalo,
      }),
    };
    const result = await cacheApi(label, cacheBody);
    if (!result.isAxiosError) {
      setTags(result.data.rows);
      setRowCount(result.data.count);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  return (
    <ListLayout
      title="Tags"
      loading={loading}
      onClickCadastrar={onClickCadastrarTag}
      permissaoButton={permissoesHelper.temPermisao(
        "meios-pagamento-cadastrar"
      )}
    >
      <DataGrid
        rows={tags}
        columns={colunas}
        onClickEdit={onClickEditTag}
        onClickDelete={onClickDeleteTag}
        visualizarShow={permissoesHelper.temPermisao("tags-visualizar")}
        editShow={permissoesHelper.temPermisao("tags-editar")}
        deleteShow={permissoesHelper.temPermisao("tags-excluir")}
        paginationMode={"server"}
        rowCount={rowCount}
        sendServer={(props) => sendServerDatagrid(props)}
        FormFiltroAvancado={FormFiltroAvancado}
      />
    </ListLayout>
  );
};

export default ListTagsView;
